import { fetchApi } from '../settings.js';

export const API_createCustomer = async customer => {
  try {
    const res = await fetchApi('/customers', {
      method: 'POST',
      body: customer,
    });

    if (res.ok) {
      const body = await res.json();
      return body.customer;
    }
    console.error('Customer creation failed with status: ', res.status);
    return null;
  } catch (err) {
    console.error('Customer creation request failed', err);
    return null;
  }
};
